import styled from 'styled-components';
import { Button } from 'antd';


export const ButtonWithIcon = styled(Button)`
	width: 115px;
	color: ${({ theme }) => theme.colors.fallow};
	
	padding: unset;

	border: 1px solid ${({ theme }) => theme.colors.fallow};
	border-radius: unset;

	svg {
		vertical-align: middle;
		
		:hover {
			color: ${({ theme }) => theme.colors.fallow};;
		}
	}
	
	&:hover,
	&:focus {
		color: ${({ theme }) => theme.colors.fallow};;
	
		border: 1px solid ${({ theme }) => theme.colors.fallow};;
		border-radius: unset;
	}
`;


export const ButtonWithBackground = styled(Button)`
	width: 115px;
	height: 40px;
	background-color: ${({ theme }) => theme.colors.fallow};;
	
	padding: unset;

	font-weight: 600;
	color: ${({ theme }) => theme.colors.white};;
	text-transform: uppercase;
	
	border: unset;
	border-radius: unset;
	
	&:hover,
	&:focus {
		color: ${({ theme }) => theme.colors.white};;
		background-color: ${({ theme }) => theme.colors.fallow};;
	}
`;
